module.exports = __webpack_public_path__ + "img/solution6.50fdb8d8.jpg";